import { lazy } from "react";

const MainPage = lazy(() => import("./page"));

const routes = [
  {
    path: "/patient-management/appointment-confirm",
    component: MainPage,
    exact: false,
    name: "Citas Médicas - Confirmación"
  }
];

export default routes;
